<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import workPlanAPI from "@/services/standards/workPlan/workPlanAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import responsabilityPlan from "@/services/standards/responsabilityPlan/responsabilityPlanAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";

/**
 * 2.4.1 Plan de Trabajo Anual SG-SST — listado.
 * Reemplaza el flujo de subida de Excel por captura estructurada + PDF branded firmado.
 * Cada fila es un plan por año (work_plans); el detalle/firma vive en plan-trabajo-editar.
 */
export default {
  page: {
    title: "2.4.1 Plan de trabajo anual",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { CheckModal, Layout, Style, PageHeader },
  data() {
    return {
      title: "2.4.1 Plan de trabajo anual",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "Plan que identifica objetivos, metas", active: true },
      ],
      lista: [],
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      yearFilter: null,
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      // Flujo anterior (subida de archivo diligenciado) — se conserva junto al form online.
      legacyList: [],
      legacyFile: null,
      legacySaving: false,
      legacyLastId: 1,
    };
  },
  computed: {
    yearOptions() {
      const current = new Date().getFullYear() + 1;
      const years = [];
      for (let y = current; y >= 2020; y--) years.push(y);
      return years;
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(15)
        .then((response) => { this.itemData = response; })
        .catch((error) => { console.log(error); });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (classificationID === 1 && item.obligatory_UPA === 1) return true;
        if (classificationID === 2 && item.obligatory_groupI === 1) return true;
        if (classificationID === 3 && item.obligatory_groupII === 1) return true;
        if (classificationID === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 15)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => { console.log(error); });
    },

    changeItemStatus(itemStatus) {
      const itemChange = { companies_id: this.companyID, item_id: 15, status: itemStatus };
      newScoresAPI.calculateScores(itemChange)
        .then(() => {
          Swal.fire({ title: "¡Éxito!", text: "¡Se ha cambiado el estado del ítem con éxito!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1000);
        })
        .catch((error) => {
          Swal.fire({ title: "¡ERROR!", text: "¡No se ha actualizado el estado del ítem!", icon: "error", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1000);
          console.log(error);
        });
    },

    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (role) {
        if (roles) {
          role = roles.includes(role) ? true : false;
        } else {
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        }
        const permissions = this.$store.state.auth.info.permissions;
        const enabled = permissions.find((permission) => permission.name === name);
        return enabled && role ? true : false;
      } else {
        return false;
      }
    },

    statusBadgeClass(status) {
      return status === "signed" ? "badge-success" : "badge-secondary";
    },
    statusText(status) {
      return status === "signed" ? "Firmado" : "Borrador";
    },

    downloadFormat() {
      const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/PLAN_DE_TRABAJO_SST_2026.xlsx";
      window.open(url, "_blank");
    },

    downloadPlan(id) {
      window.open(workPlanAPI.pdfUrl(id), "_blank");
    },

    newPlan() {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/plan-trabajo` });
    },

    editPlan(id) {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/plan-trabajo/${id}` });
    },

    deletePlan(id) {
      Swal.fire({
        title: "¿Eliminar plan?",
        text: "Se eliminará el plan y sus actividades.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        workPlanAPI.delete(id)
          .then(() => {
            Swal.fire({ title: "Éxito", text: "Plan eliminado.", icon: "success", timer: 1500, showConfirmButton: false });
            this.getList();
          })
          .catch((error) => {
            console.log(error);
            Swal.fire("Error", "No se pudo eliminar el plan", "error");
          });
      });
    },

    applyYearFilter() {
      this.getList();
    },

    getList() {
      this.loading = true;
      workPlanAPI.getAll(this.companyID, 1, this.yearFilter)
        .then((response) => {
          this.lista = (response && response.List && response.List.data) ? response.List.data : [];
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    // ---- Flujo anterior: subida/listado de archivo diligenciado (responsibility_plans) ----
    getLegacyList() {
      responsabilityPlan.getAll(this.companyID, 1)
        .then((response) => {
          this.legacyList = (response && response.List && response.List.data) ? response.List.data : [];
          if (this.legacyList.length && this.legacyList[0].id) {
            this.legacyLastId = this.legacyList[0].id + 1;
          }
        })
        .catch((error) => { console.log(error); });
    },

    async uploadLegacyDocument() {
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const url = `${base}/${this.company.nit}/2.4.1/${this.legacyLastId}/${this.legacyFile.name}`;
        const ok = await uploadDocument(url, this.legacyFile);
        return ok ? `${process.env.VUE_APP_BUCKET}/${url}` : null;
      } catch (error) {
        console.log(error);
        return null;
      }
    },

    async saveLegacy() {
      if (!this.legacyFile) {
        Swal.fire("Atención", "Selecciona un archivo primero.", "warning");
        return;
      }
      this.legacySaving = true;
      const link = await this.uploadLegacyDocument();
      if (!link) {
        this.legacySaving = false;
        Swal.fire("Error", "No se pudo subir el archivo al almacenamiento.", "error");
        return;
      }
      responsabilityPlan.save({ link_file: link, companies_id: this.companyID })
        .then(() => {
          this.legacySaving = false;
          this.legacyFile = null;
          Swal.fire({ title: "Éxito", text: "Archivo cargado correctamente.", icon: "success", timer: 1600, showConfirmButton: false });
          this.getLegacyList();
        })
        .catch((error) => {
          this.legacySaving = false;
          console.log(error);
          Swal.fire("Error", "No se pudo registrar el archivo.", "error");
        });
    },

    deleteLegacy(id) {
      Swal.fire({
        title: "¿Eliminar archivo?",
        text: "Se quitará este documento cargado.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        responsabilityPlan.delete(id)
          .then(() => {
            Swal.fire({ title: "Éxito", text: "Archivo eliminado.", icon: "success", timer: 1500, showConfirmButton: false });
            this.getLegacyList();
          })
          .catch((error) => {
            console.log(error);
            Swal.fire("Error", "No se pudo eliminar el archivo.", "error");
          });
      });
    },

    openFile(url) {
      window.open(url, "_blank");
    },
  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getList();
    this.getLegacyList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Define como empresa los objetivos y metas del SG-SST, los responsables y los recursos, y registra
                      las actividades del plan indicando en qué meses están <strong>planificadas</strong> y en cuáles
                      fueron <strong>ejecutadas</strong>. La plataforma genera el Plan de Trabajo Anual con la imagen de
                      la empresa para la firma del Representante Legal y calcula el porcentaje de avance.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-md-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="downloadFormat" class="btn btn-light mx-1">
                    <i class="bx bx-download"></i> Descargar formato (Excel)
                  </button>
                  <button :disabled="!allowAccess() || !getRole('Crear')" @click="newPlan" class="btn btn-primary mx-1">
                    <i class="mdi mdi-plus"></i> Nuevo plan
                  </button>
                </div>
              </div>

              <div class="row pt-2">
                <div class="form-row col-md-6 col-sm-12">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="form-row col-md-6 col-sm-12">
                  <b-form-group class="col-sm-12" label="Filtrar por año">
                    <b-form-select v-model="yearFilter" @change="applyYearFilter" plain class="form-control">
                      <b-form-select-option :value="null">Todos los años</b-form-select-option>
                      <b-form-select-option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr v-if="getRole('Consultar')" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="table-responsive">
                    <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                      <thead>
                        <tr>
                          <th class="text-center align-middle">Año</th>
                          <th class="text-center align-middle">Actividades</th>
                          <th class="text-center align-middle">Última actualización</th>
                          <th class="text-center align-middle">Estado</th>
                          <th class="text-center align-middle">Descargar PDF</th>
                          <th class="text-center align-middle">Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-if="loading">
                          <td colspan="6" class="text-center"><b-spinner variant="primary" small></b-spinner></td>
                        </tr>
                        <tr v-else-if="!lista.length">
                          <td colspan="6" class="text-center text-muted">No hay planes registrados.</td>
                        </tr>
                        <tr v-for="dato in lista" :key="dato.id">
                          <td class="text-center align-middle font-weight-bold">{{ dato.year }}</td>
                          <td class="text-center align-middle">{{ dato.activities_count }}</td>
                          <td class="text-center align-middle">{{ dateConvert(dato.updated_at) }}</td>
                          <td class="text-center align-middle">
                            <span class="badge" :class="statusBadgeClass(dato.workflow_status)">
                              {{ statusText(dato.workflow_status) }}
                            </span>
                          </td>
                          <td class="text-center align-middle">
                            <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;"
                              type="button" @click="downloadPlan(dato.id)" title="Descargar PDF branded">
                              <i class="mdi mdi-file-pdf-box" style="font-size:1.4rem; color:#c0392b;"></i>
                            </button>
                          </td>
                          <td class="text-center align-middle">
                            <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                              <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                              <b-dropdown-item :disabled="!getRole('Editar')" @click="editPlan(dato.id)">
                                {{ dato.workflow_status === 'signed' ? 'Ver' : 'Editar' }}
                              </b-dropdown-item>
                              <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deletePlan(dato.id)">Eliminar</b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Flujo anterior: subir/listar archivo diligenciado (se conserva junto al form online) -->
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h5 class="mb-1">Documento diligenciado</h5>
                  <p class="text-muted mb-3">
                    Opción alternativa: descarga el formato, diligéncialo, fírmalo y súbelo aquí!
                  </p>
                </div>
              </div>

              <form class="form-group" @submit.prevent="saveLegacy" v-if="allowAccess()">
                <div class="form-row">
                  <b-form-group class="col-md-9 px-2" label="Subir archivo diligenciado" label-for="legacyFile">
                    <b-form-file :disabled="!getRole('Crear')" id="legacyFile" ref="legacyFile" name="legacyFile"
                      browse-text="Buscar" placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                      v-model="legacyFile"
                      accept=".doc,.pdf,.xlsx,.xls,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                  <div class="col-md-3 px-2 d-flex align-items-end">
                    <button :disabled="!getRole('Crear') || !legacyFile || legacySaving" type="submit"
                      class="btn btn-outline-primary mb-3 w-100">
                      <b-spinner small v-if="legacySaving"></b-spinner>
                      <span v-else><i class="bx bx-upload"></i> Subir archivo</span>
                    </button>
                  </div>
                </div>
              </form>

              <div class="table-responsive" v-if="getRole('Consultar') || !allowAccess()">
                <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Fecha de carga</th>
                      <th class="text-center align-middle">Documento</th>
                      <th class="text-center align-middle">Ver archivo</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-if="!legacyList.length">
                      <td colspan="4" class="text-center text-muted">No hay documentos cargados por este método.</td>
                    </tr>
                    <tr v-for="dato in legacyList" :key="dato.id">
                      <td class="text-center align-middle">{{ dateConvert(dato.updated_at) }}</td>
                      <td class="text-center align-middle">Plan de trabajo SG-SST</td>
                      <td class="text-center align-middle">
                        <span v-if="!dato.link_file" class="text-muted">No disponible</span>
                        <button v-else :disabled="!allowAccess()"
                          style="background-color: transparent !important; border: none;" type="button"
                          @click="openFile(dato.link_file)" title="Descargar archivo">
                          <i class="mdi mdi-cloud-download" style="font-size:1.3rem;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess() || !getRole('Eliminar')"
                          style="background-color: transparent !important; border: none;" type="button"
                          @click="deleteLegacy(dato.id)" title="Eliminar">
                          <i class="mdi mdi-trash-can-outline" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
